import { render } from "./SearchTagItem.vue?vue&type=template&id=3d96d543&scoped=true&ts=true"
import script from "./SearchTagItem.vue?vue&type=script&lang=ts"
export * from "./SearchTagItem.vue?vue&type=script&lang=ts"

import "./SearchTagItem.vue?vue&type=style&index=0&id=3d96d543&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d96d543"]])

export default __exports__